// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"adbdb359","154":"0fc7499f","171":"68ab86d1","182":"be2f24b7","263":"c33340a9","382":"486924c6","616":"fa9e2f58","886":"3b06c6f8","889":"cdbc0012","925":"ba1b667e","979":"e2a2b64b"}[chunkId] + ".chunk.js";
};